import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment-timezone'
import CallListItem from './CallListItem'

const CallList = (props) => {
  const { allPatientCalls, isFetching } = props

  let callList
  if (Object.entries(allPatientCalls).length > 0) {
    const sortedCalls = allPatientCalls.sort(
      (a, b) => moment(b.ring_start).diff(moment(a.ring_start)),
    )
    if (sortedCalls.length === 0) {
      callList = <h3>There are no calls with this patient!</h3>
    } else {
      callList = sortedCalls.map(call => (
        <CallListItem
          key={call.id}
          data={call}
        />
      ))
    }
  } else if (isFetching) {
    callList = <h3>Loading...</h3>
  } else {
    callList = <h3>There are no calls with this patient!</h3>
  }

  return (
    <div>
      {callList}
    </div>
  )
}

CallList.propTypes = {
  allPatientCalls: PropTypes.array.isRequired,
  isFetching: PropTypes.bool.isRequired,
}

export default CallList



// WEBPACK FOOTER //
// ./src/components/PatientPage/Calls/CallList.js